import React from 'react'
import loadable from '@loadable/component'
import styled from 'styled-components'
import { camelize, capitalise } from '../../utils'
import { desktopVW, mobileVW } from '../../styles'
import theme from '../../styles/theme'

const SplitText = loadable(() => import('../pageBlocks/SplitText'))
const SplitImage = loadable(() => import('../pageBlocks/SplitImage'))
const Text = loadable(() => import('../pageBlocks/Text'))
const Image = loadable(() => import('../pageBlocks/Image'))
const Video = loadable(() => import('../pageBlocks/Video'))
const RelatedItems = loadable(() => import('../pageBlocks/RelatedItems'))

const { breakPoints } = theme

const allSectionPage = {
  SplitText,
  SplitImage,
  Text,
  Image,
  Video,
  RelatedItems,
}

const SectionPage = ({ block, related = [] }) => {
  const type = capitalise(camelize(block.type))

  const Component = allSectionPage[type]

  if (!allSectionPage[type])
    return (
      <div>
        Couldn't find React component, for <strong>{type}</strong>
      </div>
    )

  return (
    <Wrapper>
      <Component data={block} related={type === 'RelatedItems' && related} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin: ${mobileVW(50)} 0;

  &:first-child {
    margin-top: 0;
  }

  @media screen and (min-width: ${breakPoints.desktop}) {
    margin: ${desktopVW(80, 1440)} 0;

    &:first-child {
      margin-top: ${desktopVW(40, 1440)};
    }
  }
`

export default SectionPage
